/* eslint-disable max-len */

export default {
  lang: 'Spanish',
  homeScreen: {
    title: 'Comparte nuestra pasión',
    stayConnected: 'Manténgase conectado',
    comingSoon: 'Próximamente',
    messages: 'Mensajes',
  },
  loginScreen: {
    version2: {
      homeTitle: 'Vamos a ver si podemos encontrar un perfil existente para usted en nuestro sistema.',
      homeTitleSub:
        'Introduzca la dirección de correo electrónico que utiliza habitualmente para acceder a los programas de formaci',
      noAccount:
        'No se ha encontrado ninguna cuenta ({email}), inténtalo con otra dirección de correo electrónico o crea una cuenta ahora.',
      continueButton: 'Continuar',
      success: 'Ha actualizado correctamente su cuenta. En breve será redirigido a la página de inicio.',
      successNewAccount:
        'Para completar su inscripción, recibirá un correo electrónico de confirmación para verificar su cuenta.',
      loginButton: 'Inicio de sesión',
      matchFound: 'Hemos encontrado una coincidencia, por favor, introduzca su contraseña para continuar.',
      magicLink: 'Inicie sesión a través de un enlace en su correo electrónico:',
      magicLinkButton: 'Solicitar Magic Link',
      magicLinkTitle: 'Recibe un enlace directo en tu correo electrónico que te permitirá registrarte al instante.',
      otherEmailButton: 'Enviar',
      title:
        'Por favor, tómese un momento para completar toda la información que aparece a continuación, ya que rellenará su perfil personal y su información de contacto.',
      titleIndustry:
        'Por favor, tómese un momento para completar toda la información que aparece a continuación, ya que rellenará su perfil personal y su información de contacto.',
      register: 'Crear una cuenta',
      agent: 'Asesor de viajes',
      visitor: 'Visitante del sector',
      step1: 'Paso 1: Tipo de usuario',
      step2: 'Paso 2: Crear una cuenta',
      step3: 'Paso 3: Cree su perfil',
      milesAttack: 'Do you have a Miles Attack code? Indicate the 4 letters',
      marketingOptIn:
        '¿Está seguro de que no le interesa seguir vinculado al equipo de comercio de viajes de este programa?',
      optIn: 'Sí, me interesa',
      optOut: 'No me interesa',
      step2Sub1: 'Háblenos de usted',
      step2Sub2: 'Háblenos de su empresa',
      privacyHead: 'PREFERENCIAS DE COMUNICACIÓN',
      privacySub:
        'Marque las casillas que aparecen a continuación para asegurarse de que recibe comunicaciones importantes del equipo comercial de viajes del proveedor (actualizaciones y anuncios de productos, recompensas, incentivos, FAMs, etc.) e iniciativas de redes comerciales de viajes y apoyo a las ventas de TravPRO Mobile.',
      privacy: 'Protegemos su privacidad y nunca vendemos, abusamos o traicionamos su confianza.',
      store: 'Descarga fácilmente este programa en tu tienda de aplicaciones:',
      powered: 'PODER DE',
      toastMessage: {
        forgotSuccess:
          'Le hemos enviado por correo electrónico un enlace para restablecer su contraseña. Serás redirigido a la página de inicio de sesión en 10 segundos.',
        emailNotExisting: 'La dirección de correo electrónico que has introducido no existe.',
        magicLinkMessage: 'Por favor, espera, te estamos registrando ahora mismo.',
        magicLinkError:
          'No hemos podido encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Será redirigido en 10 segundos.',
        magicLinkError1:
          'No hemos podido encontrar un token válido, por favor inicie sesión o solicite un nuevo enlace mágico. Si este problema persiste, póngase en contacto con nosotros en: info@travpromobile.com.',
        magicLinkError2:
          'No hemos podido encontrar su cuenta en nuestra base de datos, por favor inicie sesión manualmente. Será redirigido en 10 segundos.',
        magicLinkSuccess: 'Comprueba tu correo electrónico en {email}. Tiene un enlace mágico que te registrará.',
        magicLinkErrorWait: 'Por favor, espera 5 minutos entre peticiones de enlace mágico.',
        emailNotFoundError:
          'La dirección de correo electrónico que ha introducido no se encuentra en nuestros registros. Por favor, compruebe si hay errores ortográficos o cree una cuenta.',
      },
      errors: {
        zipCodeNotFound: 'Código postal no encontrado, inténtelo de nuevo',
        zipCodeOnlyNumbers: 'El código postal sólo puede contener números',
        password: 'Introduzca una contraseña',
        passwordNotMatching: 'Las contraseñas introducidas no coinciden',
        passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
        emailExists:
          'Esta dirección de correo electrónico ya existe o no es válida. Inténtelo con otra dirección de correo electrónico o acceda a su cuenta.',
        fillInAllFields: 'Rellene todos los campos obligatorios',
        fillInEmail: 'Por favor, introduzca su dirección de correo electrónico.',
        emailNotExisting: 'La dirección de correo electrónico que ha introducido no existe.',
      },
      fields: {
        forgotSubCopy: '¿Has olvidado tu contraseña y quieres cambiarla? ',
        forgotSubCopy2:
          '¿Quiere saltarse la contraseña por completo? Le enviaremos un correo electrónico con un enlace mágico que le permitirá acceder automáticamente al programa. ',
        city: 'Ciudad',
        companyName: 'Nombre de la empresa',
        role: 'Su función',
        description: '¿Cuál describe mejor la actividad de su empresa?',
        country: 'País',
        password: 'Contraseña',
        passwordRegister: 'Elija una contraseña (mínimo 8 caracteres)',
        passwordConfirm: 'Confirmar contraseña',
        firstName: 'Nombre',
        lastName: 'Apellido (Familia)',
        agency: 'Nombre de su agencia',
        title: 'Su función (seleccione una)',
        company: 'Nombre de la empresa',
        select: 'Seleccione una opción',
        state: 'Estado',
        province: 'Provincia/Región/Estado',
        zipCode: 'Código postal',
        postalCode: 'Código postal',
        affiliate: '¿A qué grupo está afiliada su agencia PRINCIPAL?',
        hostAgency: '¿Su agencia de acogida?',
        executive: 'Ejecutivo',
        management: 'Gestión',
        marketing: 'Marketing',
        sales: 'Ventas',
        coordinator: 'Coordinador',
        opt: 'Manténgase en contacto con el equipo de comercio de viajes de este programa y reciba actualizaciones.',
        optMarketing: 'Manténgase en contacto con TravPRO en relación con programas y eventos similares.',
        retail: 'Fachada de tienda',
        home: 'Agente a domicilio',
        independent: 'Contratista independiente',
        host: 'Organismo anfitrión',
        call: 'Centro de llamadas o agencia web',
        other: 'Otros',
        describes: '¿Qué es lo que mejor describe su actividad y la de su agencia?',
        milesAttack: 'Code Miles Attack (facultatif)',
      },
    },
    title: 'Programa de capacitación profesional de turismo y facilitación de ventas',
    welcome: {
      headerTop: 'Bienvenido al',
      headerBottom: 'Programa de especialistas en Canadá',
    },
    sellingPoints: {
      0: 'Aprenda, promueva y venda sobre la marcha',
      1: 'Capacitación multimedia para todos los dispositivos',
      2: 'Certificado de finalización',
      3: 'Presentaciones de venta listas',
      4: 'Materiales promocionales de gran impacto',
      5: 'Consejos y promociones',
      6: 'Directorio de productos en tiempo real',
      7: 'Noticias y actualizaciones oportunas',
    },
    emailPrompt:
      'Ingrese su dirección de correo electrónico y contraseña para confirmar que es un agente de viajes profesional.',
    tAndC: {
      agree: 'Al continuar, acepta nuestra ',
      privacyPolicy: 'política de privacidad',
      and: ' y ',
      termsConditions: 'nuestros términos y condiciones',
    },
    fields: {
      select: 'Seleccione una opción a continuación',
      country: 'País',
      forgot:
        '¿Olvidaste tu contraseña? Haz clic en el botón a continuación y te enviaremos un correo electrónico para restablecer tu contraseña.',
      agency: 'Agencia',
      email: 'Correo electrónico',
      password: 'Contraseña',
      passwordConfirm: 'Confirme su contraseña',
      firstName: 'Nombre',
      lastName: 'Apellido',
      agencyName: 'Nombre de la agencia',
      stateProvince: 'Estado / Provincia',
      required: 'Obligatorio',
      invalidEmail: 'Dirección de correo electrónica no válida',
      opt: '¡Manténgase en contacto! Sí, deseo registrarme para recibir comunicaciones de Destination Canada que me mantendrán informado sobre ¡noticias, eventos, incentivos, FAM y mucho más!',
    },
    noAgent: {
      noAgentButton: 'No soy asesor',
      title: 'Gracias por su interés en el Programa de especialistas en Canadá.',
      messageWeb:
        'El contenido de este sitio es exclusivo para agentes de viaje profesionales. \n  Para obtener más información sobre Canadá, visite:',
      messageMobile:
        "Parte del contenido de esta aplicación es exclusivamente para agentes de viaje profesionales, pero puede tener una vista previa de lo que ofrece esta aplicación si presiona 'Continuar'.",
      continue: 'Continuar',
      visitWebsite: 'Visitar el sitio web',
    },
    forgot: 'Restablecer contraseña',
    newUser: 'Usuario nuevo',
    register: 'Registrarse',
    registered: 'Este correo electrónico ya está registrado',
  },
  welcomeScreen: {
    title: 'Bienvenido al Programa de especialistas en Canadá',
    helloUser: 'Hola, {{name}}',
    hello: 'Hola,',
    fromAgency: 'de {{agency}}',
    notUser: '¿No es {{name}}?',
    introOnline:
      '¡Capacítese de inmediato o precargue el contenido para que siempre esté disponible para usar fuera de línea!',
    introOffline:
      'Ya tiene la versión más actualizada precargada. ¡Comience a capacitarse o a vender en cualquier momento y lugar!',
    startTraining: 'Comenzar a aprender',
    continueTraining: 'Continuar aprendiendo',
    graduated: '¡Felicitaciones!',
    downloader: {
      preload: 'Precargar',
      stop: 'detenerse',
      init: 'Inicializando...',
      lastUpdate: 'Última actualización:',
    },
  },
  trainingScreens: {
    completedBase: 'Felicidades, usted es un especialista certificado de Canadá.',
    allUnlocked: '¡Ha desbloqueado todos los capítulos!',
    certificate: 'Certificado',
    chapter: 'Capítulo',
    chapterComplete: '¡Capítulo completo!',
    choose: 'Elija una respuesta',
    confirm: 'CONFIRMA TU RESPUESTA',
    continue: 'Continuar',
    welcome:
      'Completa los módulos y gana puntos para convertirte en Especialista en Canadá nivel oro. La barra de la derecha mostrará tu avance.',
    courseComplete: '¡Curso completo!',
    durationInMinutes: '{number} minutos',
    endReached: 'Ha llegado al final',
    essential: 'LO BÁSICO',
    essentialSub: 'Completa los módulos esenciales para obtener el nivel bronce.',
    message: '{count} mensaje con ESTRELLA',
    messagePlural: '{count} mensajes con ESTRELLA',
    percentageComplete: '{number}% Finalizado',
    restart: 'Volver a iniciar',
    retainEnd: 'Use la barra superior para recorrer este capítulo o presione el botón volver para regresar al resumen.',
    retry: 'Intente otra vez',
    skip: 'Volver >',
    viewAllTitle: 'Consejo de capacitación',
    viewAll:
      'Para continuar a la próxima página, haga clic en los íconos para ver el contenido complementario. Se proporcionaron videos, mapas y otras informaciones útiles para mejorar su capacitación y garantizar que logre el estado PRO.',
    specialization: 'Módulos de especialización',
    specializationSub: 'Finalice estos módulos para lograr tu estado de Especialista plateado en Canadá',
    start: 'Comenzar',
    review: 'Revisar',
    status: 'NIVEL ACTUAL:',
    tip: 'Obtendrá su estado al completar<br />los módulos en cada nivel. <br />¡Sueñe en grande y logre el estado de Especialista dorado en Canadá<br />al completar todos los módulos!',
    trouble:
      'Parece que tiene problemas, vuelva a leer el contenido de la(s) página(s) anterior(es) e intente otra vez.',
    unlock: 'Desbloquee este capítulo al completar el capítulo de capacitación {number}.',
    unlockSubtitle: 'Desbloquee más capítulos al completar capítulos de capacitación.',
    unlockFoundation: 'Desbloquea este capítulo completando los Capítulos de la Fundación.',
    watchListenRead: 'Mira, escucha y lee más',
  },
  newTrainingFlow: {
    tip: 'Consejo: ganará su estado al completar los módulos dentro de cada nivel. ¡Sueñe en grande y logre el estado de Especialista dorado en Canadá al completar todos los módulos!',
    essentialModules: 'Capítulos Esenciales',
    finishBronze: 'Complete estos módulos para lograr el estado de Especialista bronce en Canadá',
    specializationModules: 'Módulos de especialización',
    finishSilver: 'Finalice estos módulos para lograr tu estado de Especialista plateado en Canadá',
    partnerModules: 'Módulos para socios',
    finishGold:
      'Lleve su conocimiento al siguiente nivel y gane una insignia por CADA capítulo de provincia, territorio o ciudad que complete. Termine 10 de los 29 capítulos totales y obtenga el estado GOLD. Complete 22 de los 29 capítulos totales y alcance el estado de especialista más alto, ¡PLATINO!',
    currentStatus: 'Estado actual',
    pointsToLevel: '¡{pointsToLevel} {points}',
    reachedRanking: 'para llegar a la calificación {rank}!',
    outOf: '{points} de experiencia de',
    pointsToRank: '{pointsToLevel} de experiencia necesarios para calificar: ({rank})',
  },
  points: {
    pointsToLevel: '¡{pointsToLevel} {points} para llegar a la calificación {rank}!',
    outOf: '{points} de experiencia de',
    unit: 'Experiencia',
    pointsToRank: '{pointsToLevel}de experiencia necesarios para calificar: ({rank})',
    complete: {
      chapter: '¡Capítulo completo!',
      'intro-chapter': '¡Capítulo de introducción completo!',
      'sub-app': '¡SubApp completo!',
      rewards: '¡Recompensas completas!',
      multi: '¡Le faltan algunos puntos!',
    },
    completed: '{completed} / {total} completados',
  },
  nav: {
    home: 'Inicio',
    train: 'Aprender',
    learn: 'Aprender',
    retain: 'Repasar',
    achievements: 'Logros',
    directory: 'Directorio',
    showRoom: 'Características destacadas del hotel',
    showcases: 'Características destacadas del hotel',
    promote: 'Promocionar',
    sell: 'Vender',
    info: 'Información',
    rewards: 'Recompensas',
    media: 'Prensa',
    favorites: 'Favoritos',
    contact: 'Contacto',
    reportCard: 'Ver diploma',
    accountSettings: 'Ajustes de la cuenta',
    messages: 'Mensajes',
    search: 'Buscar',
  },
  contentHeaders: {
    train: 'Aprender',
    retain: 'Repasar',
    subapps: 'Programa de especialistas en Canadá',
    maintrainings: 'LO BÁSICO',
    subtrainings: 'La Experiencia',
  },
  pageDescriptions: {
    train: 'Capacítate, comprométete y conviértete en experto.',
    showroom: '',
    retain:
      'Esta sección te servirá para repasar lo que has aprendido hasta el momento. Usa la información para responder a preguntas sobre el destino como experto, incluso la puedes emplear para realizar una presentación de ventas en cualquier momento y desde cualquier dispositivo.',
    promote: 'Inicia la conversación con tus clientes potenciales y actuales.',
    sell: 'Responde las preguntas de tus clientes y cierra la venta.',
    favorites: 'Consulte su contenido favorito',
    search: 'Revise todo el contenido',
    subapps:
      'Lleve su conocimiento al siguiente nivel y gane una insignia por CADA capítulo de provincia, territorio o ciudad que complete. Termine 10 de los 29 capítulos totales y obtenga el estado GOLD. Complete 22 de los 29 capítulos totales y alcance el estado de especialista más alto, ¡PLATINO!',
    maintrainings: 'Finalice los módulos de base para obtener su diploma',
    subtrainings: 'Profundice en las diferentes experiencias de Canadá y obtenga el estado plateado.',
  },
  general: {
    forgot: '¿Olvidó la contraseña?',
    next: 'Siguiente',
    yes: 'Sí',
    no: 'No',
    previous: 'Anterior',
    submit: 'Enviar',
    register: 'Registrarse',
    back: 'Atrás',
    close: 'Cerrar',
    page: 'Página',
    search: 'Buscar',
    logIn: 'Iniciar sesión',
    logOut: 'Cerrar sesión',
    viewItem: 'Ver {type}',
    imageNotFound: 'No se encontró la imagen',
    noResultsFor: 'No se encontraron resultados sobre: {{query}}',
    noFavorites: 'Todavía no tiene ningún favorito.',
    noMessages: '¡Todavía no ha recibido ningún mensaje!',
    resultsFor: 'Resultados sobre: {{query}}',
    showAll: 'Mostrar todo',
    connectionError: 'Error de conexión',
    alreadyExists: 'Ya existe',
    pageNotFound: '¡404 No se encontró la página!',
    oops: 'Oh, oh...',
    overview: 'Volver al resumen',
    complete: 'Continuar',
    courseComplete: '¡MÓDULO COMPLETO!',
    chapterComplete: '¡MÓDULO COMPLETO!',
    message: '{count} mensaje',
    messagePlural: '{count} mensajes',
  },
  itemTypes: {
    image: 'Imagen',
    brochure: 'Grupo',
    layout: 'Disposición',
    web: 'Sitio web',
    pdf: 'PDF',
    carousel: 'Grupo',
  },
  questions: {
    dials: 'Gire las perillas para hacer coincidir la respuesta',
    fitb: 'Complete el(los) espacio(s) en blanco',
    flip: 'Cambie el número para hacer coincidir la respuesta',
    multipleChoice: 'Elija la(s) respuesta(s) correcta(s)',
    slider: 'Elija la respuesta correcta con la barra deslizadora',
    map: 'Toque el lugar correcto en el mapa para responder la pregunta',
    dropdown: 'Elegir...',
    true: 'Verdadero',
    false: 'Falso',
  },
  reportCard: {
    download: 'Descargar',
    email: 'Correo electrónico',
    print: 'Print',
  },
  cookies: {
    consent: 'ACEPTAR',
    optout: 'Cancelar suscripción',
    settings: 'Ajustes de privacidad',
    message:
      '¡No nos ha informado nada sobre sus preferencias en cuanto a la privacidad de los datos! Está bien, pero nos gustaría ofrecerle la mejor experiencia mediante el uso de Compañero de ventas.',
    disabled: 'Parece que ha desactivado el uso de cookies.',
    use: '{{appName}} requiere el uso de cookies para brindarle la mejor experiencia.',
    details: '¿Para qué se usan las cookies?',
    enable: 'Consulte cómo activar sus cookies {{here}}.',
    here: 'aquí',
  },
  notLoggedIn: {
    super: 'No ha iniciado sesión',
    title: 'Debe iniciar sesión para ver este contenido',
    guest: 'Invitado',
  },
  demo: {
    message:
      'Este sitio web es una demostración del producto final. Actualmente, está en desarrollo y no es un producto completo.',
    consent: '¡Entiendo!',
  },
  share: {
    header: '¡Comparta este recurso en sus redes sociales favoritas!',
    download: 'Descargar',
  },
  sharing: {
    email: 'Correo electrónico',
    facebook: 'Facebook',
    twitter: 'Twitter',
    download: 'Descargar',
    print: 'Imprimir',
    copy: 'Copiar enlace',
    copyURL: 'Copiar enlace',
    copied: 'Copiado',
    shareSubjectDiploma: 'Mi Diploma del Programa de Especialista en Canadá',
    shareSubjectBadge: 'Mi Insignia del Programa de Especialista en Canadá',
    shareBodyDiploma:
      '¡Estoy emocionado/a de compartir que ahora soy un Especialista Certificado en Canadá! Esto significa que tengo la experiencia y el acceso exclusivo para ayudarte a planificar las mejores vacaciones posibles. Por favor, contáctame cuando estés listo/a para comenzar a planificar.',
    shareBodyBadge:
      'Quería informarte que ahora soy un especialista certificado en {chapterTitle}, y estaré encantado/a de responder a tus preguntas y ayudarte a planificar tu próximo viaje increíble. Avísame cuando estés listo/a para empezar.',
  },
  popUp: {
    congratulations: 'CONGRATULATIONS!',
    bronze:
      'Nice work! You’ve learned all about the essentials of Canada and have earned BRONZE status. Next, we’ll explore the many types of experiences visitors can have here.',
    silver:
      'Congratulations! You have earned your diploma as a certified Canada Specialist by successfully completing all modules in The Foundation and The Experience. You have also achieved SILVER status and are ready to go for GOLD and beyond by proceeding into the Provinces, Territories & Cities section below. Keep up the great work!',
    gold: 'Great work! You have successfully completed 10 Provinces, Territories & Cities modules and have now earned GOLD status. Choose to complete another 12 and you become a full PLATINUM-level Canada Specialist!',
    platinum:
      'Congratulations!! You have earned PLATINUM status — the highest level of qualification as a certified Canada Specialist. Thank you for all your hard work and your partnership in selling Canada.',
    platinumWithLink: {
      start:
        'You have just achieved PLATINUM status as a Canada Specialist. You are truly at the top of the class now, well done! You have earned some rewards for your hard work. Click',
      end: 'to visit your Achievements Dashboard and learn how to redeem exclusive PLATINUM deals and offers from our partners.',
      link: 'HERE',
    },
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header: 'Parece que intenta acceder a la aplicación {appName} desde un dispositivo móvil',
    body: 'Para descargar este programa, simplemente visite la tienda de aplicaciones y busque {appName} o haga clic en uno de los botones a continuación',
    benefits: {
      1: 'Aprenda, promueva y venda sobre la marcha',
      2: 'Capacitación multimedia en todos los dispositivos',
      3: 'Certificado de finalización',
      4: 'Presentaciones de venta listas',
      5: 'Materiales promocionales de gran impacto',
      6: 'Directorio de productos en tiempo real',
      7: 'Noticias y actualizaciones oportunas',
      header: 'Esto le brindará:',
    },
  },
  rewards: {
    profile: 'Your Profile',
    rewards: 'Rewards',
    title: 'CENTRO DE RECOMPENSAS',
    subheader: 'Prizes / Points / Booking Contest',
    subTitle:
      'We’re giving you a chance to win rewards for becoming a specialist with our program, and booking travel to The Canada!',
    body: 'Book travel to The Canada for your chance to win! Enter your bookings for eligibility to earn an Introductory Incentive Reward of $5 US/CAN E-gift Card.',
    item1:
      'After your first confirmed booking of 4-nights or more, (for an individual reservation), for a minimum of two (2) passengers, at a qualifying hotel/resort. (Cruises do not qualify.)',
    item2: 'Offer valid after Essential Modules of the Canada Specialist Programme Program are completed.',
    link1: 'Have you booked the Canada? ',
    link2: 'If so, submit your booking here.',
    button: 'Submit your booking',
    products: 'Marketplace',
    viewAllBookings: 'Bookings Dashboard',
    viewLeaderboard: 'Leaderboard',
    viewDashboard: 'Panel de Logros',
    viewRewards: 'Inicio de Recompensas',
    form: 'SUBMIT BOOKING ',
    overview: {
      title: 'Bienvenido al Centro de Recompensas de Canada Specialist.',
      subtitle:
        'Utilice esta sección especial para realizar un seguimiento de su progreso de entrenamiento, sus logros y sus recompensas. ',
      description: 'He aquí cómo:',
      dashboard: {
        title: 'PANEL DE LOGROS',
        description:
          'Realiza un seguimiento de tu progreso de entrenamiento, diploma e insignias obtenidas visitando el panel de logros. A medida que avances de los niveles Bronce a Platino, podrás ver cómo crece tu estatus en la barra de seguimiento.',
        bronze: 'La categoría BRONCE se obtiene tras completar los capítulos de la Fundación.',
        silver: 'La categoría PLATA se obtiene, junto con el diploma, tras completar los capítulos de Experiencia.',
        gold: 'La categoría ORO se obtiene tras completar 10 capítulos de Provincias/Territorios/Ciudades.',
        platinum: 'El estatus PLATINUM se obtiene tras completar 22 capítulos de Provincias/Territorios/Ciudades.',
      },
      platinumRewards: {
        title: 'PREMIOS PLATINO',
        description:
          'Los Especialistas en Canadá de nivel Platino obtienen recompensas especiales como Pases de Experiencia de Destino de nuestros socios de destino. Una vez que reciba su Insignia Platino en el Panel de Logros, obtendrá una lista de los Pases de Experiencia disponibles e instrucciones para canjearlos. Para canjearlo, deberá descargar su insignia de platino y enviarla a los destinos asociados para su verificación.',
      },
      downloads: {
        title: 'DESCARGAS',
        description:
          'El Panel de Logros le permite ver y descargar su Diploma de Especialista de Canadá, insignias por Provincias/Territorios/Ciudades, así como sus insignias metálicas de estado. Solo tiene que hacer clic en el icono para abrirlo y guardarlo en su ordenador y compartirlo con orgullo con sus clientes actuales y potenciales.',
      },
      termsNotice: {
        start: 'See terms',
        end: 'for more details.',
        link: ' Terms & Conditions ',
      },
      rewards: {
        title: 'Rewards',
        description: {
          start: 'Platinum-level Canada Specialists earn special rewards like',
          end: "from our destination partners. Once you receive your Platinum badge in the Achievements Dashboard, you'll get a list of the available Experience Passes and instructions for redemption.",
          bold: 'Destination Experience Passes',
        },
      },
    },
    bookingRewardsView: {
      title: 'Marketplace',
    },
    bookingsView: {
      title: 'BOOKINGS DASHBOARD',
    },
    leaderboardScreen: {
      title: 'LC POINTS \n Leaderboard',
      earnedpts: 'MY LC POINTS EARNED​:',
      pointsWall: 'LC POINTS TOP 5 TRACKER​:',
      startEarning: "Start now earning XP's and join the leaderboard!",
      prizes: 'Prizes',
      tAndC: 'Terms and Conditions apply*',
      pointsOverview: {
        title: 'How to earn points',
        booths: 'Visit Exhibitor Showcases',
        breakoutSessions: 'Attend Breakout Sessions & Destination Spotlights',
        trainingSessions: 'Complete a Training Chapter',
        adventureSpotlights: 'Family Travel Tips',
        share: 'Sharing Content',
        shareMax: '(up to {maxSharePoints} points)',
        shareInfo:
          'Sharing is counted by sharing booth content to Twitter and Facebook or sharing the entire booth with colleagues or clients.',
        viewVideo: 'View Video',
      },
    },
    dashboardView: {
      title: 'Your Earnings Dashboard',
    },
    bookingForm: {
      title: 'BOOKING CREDIT FORM​',
      subTitle: 'Your Profile',
      required: '* Indicates a required field',
      email: 'Advisor email',
      agentFirstName: 'Advisor First Name',
      agentLastName: 'Advisor Last Name',
      company: 'Agency / Company Name',
      iata: 'IATA/CLIA #',
      stateProvince: 'State/ Province',
      postalCode: 'Zip / Postal Code',
      country: 'Country',
      city: 'City',
      birthday: 'Birthday',
      type: 'Guest Trip Type',
      source: 'Booking Source',
      tourOperator: 'Tour Operator',
      firstName: 'Guest First Name',
      lastName: 'Guest Last Name',
      confirmNumber: 'Booking Confirm Number',
      file: 'RezSnap™ Proof Upload ',
      arrivalDate: 'Property Arrival Date',
      departureDate: 'Property Departure Date',
      brand: 'LC Brand Booked',
      lengthOfStay: 'Length of Stay (in Nights)',
      cost: 'Total Cost of Booking',
      rooms: 'Number of Rooms',
      stay: 'Length of Stay (in Nights)',
      airline: 'Airline/ Carrier (2- digit code)',
      gateway: 'Origin Gateway (3- letter airport code)',
      destination: 'Destination/ island (3- letter airport code)',
      disclaimer: '* Required fields',
      button: 'Submit your booking',
      sub: 'Your information',
      sub2: 'Booking information',
    },
    TermsAndConditions: {
      title: 'Terms and Conditions',
      subTitle: 'Canada Specialist Quarterly Rewards',
      body1:
        'All posting must be accompanied by a zero-balance proof of sale document that corresponds with each individual booking that you have posted. Awardees will be selected based on the totality of verified proof of sale documents corresponding with each listed booking. Postings must follow all Bahamas Specialist Rewards rules for eligibility. Awards are not transferable and must be redeemed within three (3) months of award notification. Any unused, unclaimed or declined awards will be forfeited. Awards will be issued quarterly, and eligibility will be verified based on completed travel.',
      body2:
        'To be eligible you must reside in the U.S or Canada, and be age of majority or older in the state, province, or territory of residence. Tour Operator employees are NOT eligible for drawings, and will NOT be considered for additional prizes. Residents of the Province of Quebec are NOT eligible for drawings, and will NOT be considered for additional prizes.',
      body3:
        'Reward issuance may require proof of accreditation as a retail/home-based travel counselor. Available rewards are subject to change during the course of the program.',
      body4: 'Privacy and Use of Personal Information',
      body5:
        'Participating agents (i) grants to the Rewarder the right to use his/her name, city, state, province, postal code, age of majority confirmation, telephone number and e-mail address for including but not limited to contacting and announcing the Awardees and provision of awards; (ii) grants to the Awardee the right to use his/her personal information for publicity and promotional purposes relating to the awards, in any and all media now known or hereafter devised, without further compensation unless prohibited by law; and (iii) acknowledges that the Awardees may disclose his/her personal information to third-party agents and service providers in connection with any of the activities listed in (i) and (ii) above.',
      button: 'Return to landing',
    },
    thankYouPage: {
      thanks: 'Thank you',
      congrats: 'Congratulations, ',
      body: 'your booking has been received and sent to the campaign supervisor for verification.',
      link: 'Please note to be a winner, you must have completed the Essential Modules of the Canada Specialist Program',
    },
  },
  custom: {
    splitUsers: 'Soy un...',
    brandAmbassador: 'Embajador de marca',
    travelPro: 'Agente de viajes profesional',
  },
  badgeView: {
    title: 'Panel de logros',
    subtitle:
      'Bienvenido a tu panel de logros, donde puedes ver, seguir y descargar tus insignias de diploma y especialización',
    viewBadge: 'Ver estado',
    badgeDisplayTitle: 'Estado de logros',
    badgeAchievement:
      '      «¡Has alcanzado el {rank}! Haz clic en el icono de la insignia que aparece a continuación para ver y compartir tu estado».',
    badgesCompleteTitle: 'Tus insignias de especialización',
    badgesCompleteSubtitle: 'Haz clic en los iconos para ver, guardar y compartir tus insignias',
    badgesIncompleteSubtitle: 'Gana más insignias completando estos capítulos',
    bronze: 'Bronce',
    silver: 'Plata',
    gold: 'Oro',
    platinum: 'Platino',
    diploma: 'Diploma',
    badgeAchievementWithRewards: {
      start: '¡Enhorabuena! Ha alcanzado la categoría Platino. Haga clic en ',
      link: 'aquí',
      end: ' para acceder a su recompensa de Estatus Platino.',
    },
  },
  search: {
    pages: 'Páginas',
    resources: 'Recursos',
  },
};
